"use client";

import { useEffect, useState } from "react";

// ── Store URLs ──
// utm_medium is appended per placement by the caller.
export const CHROME_URL =
  "https://chromewebstore.google.com/detail/flamcjcggbcpcdjpjheemmbknajhjbnn";
// TODO: replace the slug once AMO approves the listing (it may differ).
export const FIREFOX_URL =
  "https://addons.mozilla.org/en-US/firefox/addon/audio-spatializer-by-8dfy/";

export type BrowserTarget = "chrome" | "firefox";

export interface InstallTarget {
  browser: BrowserTarget;
  storeName: string; // "Chrome Web Store" | "Firefox Add-ons"
  shortLabel: string; // "Chrome" | "Firefox"
  baseUrl: string;
}

function detect(): BrowserTarget {
  if (typeof navigator === "undefined") return "chrome";
  const ua = navigator.userAgent;
  // Firefox (and forks) report "Firefox/x"; exclude Seamonkey/Waterfox-as-Firefox edge cases loosely.
  if (/\bFirefox\//i.test(ua) && !/Seamonkey/i.test(ua)) return "firefox";
  return "chrome"; // Chrome, Edge, Brave, Opera, Arc, Safari → Chrome listing (default)
}

const TARGETS: Record<BrowserTarget, InstallTarget> = {
  chrome: {
    browser: "chrome",
    storeName: "Chrome Web Store",
    shortLabel: "Chrome",
    baseUrl: CHROME_URL,
  },
  firefox: {
    browser: "firefox",
    storeName: "Firefox Add-ons",
    shortLabel: "Firefox",
    baseUrl: FIREFOX_URL,
  },
};

/**
 * Returns the install target for the visitor's browser. SSR-safe: renders the
 * Chrome default on the server + first client paint (matching prerendered HTML,
 * so no hydration mismatch), then swaps to Firefox after mount if detected.
 */
export function useInstallTarget(): InstallTarget {
  const [browser, setBrowser] = useState<BrowserTarget>("chrome");
  useEffect(() => {
    setBrowser(detect());
  }, []);
  return TARGETS[browser];
}

/** Append UTM params for a given placement (medium). */
export function withUtm(baseUrl: string, medium: string): string {
  const sep = baseUrl.includes("?") ? "&" : "?";
  return `${baseUrl}${sep}utm_source=8dfy.xyz&utm_medium=${medium}`;
}
